/* Homepage redesign 2026-10: customer clip in sections/ei-customers.liquid.
   Plays muted + inline only while on screen and the tab is visible. Reduced motion or Save-Data:
   no autoplay, the first frame stays up with a play button. A pause button is always available.
   Perf: at load this only registers one IntersectionObserver; each clip is wired up about a screen
   before it scrolls into view. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  function manualOnly() { return saveData || (mq && mq.matches); }

  function setup(wrap) {
    if (wrap.hasAttribute('data-ei-ready')) return;
    var v = wrap.querySelector('video');
    var btn = wrap.querySelector('.ei-cust__vbtn');
    if (!v || !btn) return;
    wrap.setAttribute('data-ei-ready', '');

    var userPaused = false;
    var userStarted = false;
    var inView = false;

    function sync() {
      var playing = !v.paused && !v.ended;
      wrap.classList.toggle('is-playing', playing);
      btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
    function wantsPlay() {
      return inView && !document.hidden && !userPaused && (userStarted || !manualOnly());
    }
    function play() {
      v.muted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () { sync(); });
    }
    function update() {
      if (wantsPlay()) { if (v.paused) play(); }
      else if (!v.paused) { v.pause(); }
    }

    wrap.classList.toggle('is-manual', manualOnly());
    btn.hidden = false;

    v.addEventListener('playing', function () { wrap.classList.add('has-played'); sync(); });
    v.addEventListener('pause', sync);
    btn.addEventListener('click', function () {
      if (v.paused) { userPaused = false; userStarted = true; inView = true; play(); }
      else { userPaused = true; v.pause(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; update(); });
      }, { threshold: 0.35 }).observe(wrap);
    }
    document.addEventListener('visibilitychange', update);
    if (mq && mq.addEventListener) {
      mq.addEventListener('change', function () { wrap.classList.toggle('is-manual', manualOnly()); update(); });
    }
    sync();
  }

  var wraps = document.querySelectorAll('.ei-cust__media[data-ei-video]:not([data-ei-ready])');
  if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(wraps, setup); return; }
  var near = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { near.unobserve(e.target); setup(e.target); }
    });
  }, { rootMargin: '100% 0px' });
  Array.prototype.forEach.call(wraps, function (w) { near.observe(w); });
})();
